// src/pages/admin/UpdatePassword.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function UpdatePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 로그인 상태 확인
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    
    if (isLoggedIn !== 'true') {
      alert('로그인이 필요합니다.');
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('모든 필드를 입력해주세요.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('새 비밀번호가 일치하지 않습니다.');
      return;
    }

    // 비밀번호 복잡성 검사
    if (newPassword.length < 8) {
      setError('새 비밀번호는 최소 8자 이상이어야 합니다.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // JSON 형식으로 전송, 파라미터 이름을 DB 컬럼명과 일치시켜 보기
      const response = await axios.post(
        '/api/admin/password',
        {
          // 여러 파라미터 이름을 시도해보기
          // 원래 사용하던 이름
          currentPassword: currentPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
          
          // DB 컬럼 이름과 유사한 이름 (추가로 포함)
          ad_pw: currentPassword,
          pw: currentPassword,
          new_pw: newPassword,
          confirm_pw: confirmPassword
        },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }
      );

      // 응답 처리
      if (response.data.success) {
        alert('비밀번호가 성공적으로 변경되었습니다.');
        navigate('/admin/contact');
      } else {
        setError(response.data.message || '비밀번호 변경에 실패했습니다.');
      }
    } catch (err) {
      console.error('Password update error:', err);
      
      if (err.response && err.response.data) {
        setError(err.response.data.message || '서버 오류가 발생했습니다.');
      } else {
        setError('비밀번호 변경 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <h2 className="prt-bold fs-30 mb-3">비밀번호 변경</h2>

      {error && (
        <div className="error-message prt-regular fs-16 mt-2 mb-2">{error}</div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="currentPassword" className="prt-medium fs-18">
            현재 비밀번호
          </label>
          <input
            type="password"
            id="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="newPassword" className="prt-medium fs-18">
            새 비밀번호
          </label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <small className="form-text text-muted">
            최소 8자 이상, 영문, 숫자, 특수문자를 포함해야 합니다.
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword" className="prt-medium fs-18">
            새 비밀번호 확인
          </label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-cancel"
            onClick={() => navigate(-1)}
          >
            취소
          </button>
          <button
            type="submit"
            className="btn-submit"
            disabled={loading}
          >
            {loading ? '처리 중...' : '비밀번호 변경'}
          </button>
        </div>
      </form>
    </div>
  );
}